import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../core/i18n/translate.pipe';

export interface ConfirmActionDialogData {
  actionLabel: string;
  description?: string;
}

@Component({
  selector: 'app-confirm-action-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslatePipe],
  template: `
    <h2 mat-dialog-title>{{ 'actionConfirm.title' | t }}</h2>
    <mat-dialog-content>
      <p>{{ 'actionConfirm.message' | t: { action: data.actionLabel } }}</p>
      @if (data.description) {
        <p>{{ data.description }}</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">{{ 'common.cancel' | t }}</button>
      <button mat-flat-button color="primary" type="button" (click)="dialogRef.close(true)">{{ 'actionConfirm.confirm' | t }}</button>
    </mat-dialog-actions>
  `
})
export class ConfirmActionDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmActionDialogComponent, boolean>);
  readonly data = inject<ConfirmActionDialogData>(MAT_DIALOG_DATA);
}
